import { z } from 'zod';

export const WEB_EXPOSE_STATUSES = ['NOT_PUBLISHED', 'PUBLISHED', 'WITHDRAWN'] as const;
export type WebExposeStatusView = (typeof WEB_EXPOSE_STATUSES)[number];

export const WebExposeViewSchema = z.object({
  status: z.enum(WEB_EXPOSE_STATUSES),
  // null while NOT_PUBLISHED, and whenever the workspace has no Web-Adresse.
  url: z.url().nullable(),
  showAddress: z.boolean(),
  onlineSince: z.iso.datetime().nullable(),
  withdrawnAt: z.iso.datetime().nullable(),
  openingCount: z.number().int().nonnegative(),
  lastOpenedAt: z.iso.datetime().nullable(),
});
export type WebExposeView = z.infer<typeof WebExposeViewSchema>;
